// Contract types mirroring the read-plane metadata DTO.
//
// Server source of truth: _src/infra/lambda/get_file_metadata.py
// response shape — the `data` field of the generic `{error?, data?}`
// envelope defined in shared/errors.py. The SPA only reads these
// fields; the server may add more without breaking us.

/** The 6 canonical render hints the server emits. */
export const RENDER_HINTS = [
  'markdown',
  'html',
  'json',
  'image',
  'text',
  'binary',
] as const;

export type RenderHint = (typeof RENDER_HINTS)[number];

export function isRenderHint(value: unknown): value is RenderHint {
  return typeof value === 'string' && (RENDER_HINTS as readonly string[]).includes(value);
}

export interface FileMetadata {
  filename: string;
  size_bytes: number;
  content_type: string;
  render_hint: RenderHint;
  expires_at: string;
  content_url: string;
}

/** Generic server response envelope (error shape). */
export interface ServerError {
  code: string;
  message: string;
  correlation_id?: string;
}
